import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'td-wb-split-button-data',
  template: '<ng-content />',
  styleUrls: ['./split-button-data.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SplitButtonDataComponent {
}
